import React from 'react';
import PropTypes from 'prop-types';
import { FULLSTORY_SCRIPT } from './constants';
import { logEvent } from '../../utils';
import { EVENT_TYPES, BusinessUnit } from '../../../constants';

let loadedFullStory = false;
export const __resetVariablesForUnitTests = () => (loadedFullStory = false);

export default class FullStory extends React.PureComponent {
    static propTypes = {
        bookingId: PropTypes.string,
        shouldLoadFullStory: PropTypes.bool,
    };

    static defaultProps = {
        shouldLoadFullStory: false,
    };

    componentDidMount() {
        this.maybeLoadFullStory();
    }

    componentDidUpdate() {
        this.maybeLoadFullStory();
    }

    render() {
        return <span />;
    }

    maybeLoadFullStory() {
        if (!loadedFullStory && this.props.shouldLoadFullStory) {
            // Sets a callback which is called when FullStory finishes loading
            // Reference: https://help.fullstory.com/develop-js/getcurrentsessionurl
            window._fs_ready = () =>
                logFullStorySessionUrl(this.props.bookingId);
            appendFullStoryScript();
            loadedFullStory = true;
        }
    }
}

function appendFullStoryScript() {
    const fullstoryScript = document.createElement('script');
    fullstoryScript.defer = true;
    fullstoryScript.innerHTML = FULLSTORY_SCRIPT;
    document.body.appendChild(fullstoryScript);
}

export function logFullStorySessionUrl(bookingId) {
    if (typeof FS === 'undefined' || !bookingId) return;

    const sessionUrl = FS.getCurrentSessionURL(); // eslint-disable-line no-undef

    logEvent({
        event: {
            type: EVENT_TYPES.FullStoryUrl,
            data: { URL: sessionUrl },
        },
        bookingId,
        businessUnit: BusinessUnit.PATIENT_WEB_APP,
    });
}
